export interface ActivityFeedItem {
  id: number
  type: string
  title: string
  label: string
  icon: string
  entity_type: string
  entity_id: number
  summative_id: number
  formative_id: number
  assignment_id: number
  created_at: string
}

export interface AssessmentQuestions {
  total: number
  answered: number
}

export interface SummativeAssessment {
  id: number
  name: string
  last_activity: string | null
  questions: AssessmentQuestions
  time_spent: number
  score: number | string | null
  is_enabled: boolean
  is_completed: boolean
  is_started: boolean
}

export interface FormativeAssessment {
  id: number
  name: string
  attempt?: number
  objective_id: number
  objective_name: string
  formative_quiz: any
  lesson_guided_practice: any
  independent_practice: any
  continuous_practice: any
}

export enum TestTypeEnum {
  BENCHMARKS = 'benchmarks',
  SUMMATIVES = 'summatives',
  FORMATIVES = 'formatives',
  PRACTICE = 'practice'
}

export enum AssignmentType {
  LESSON_GUIDED = 'LESSON_GUIDED',
  INDEPENDENT = 'INDEPENDENT',
  CONTINUOUS = 'CONTINUOUS'
}

export enum StudentNotificationType {
  SUMMATIVE_ASSIGNED = 'summative_assigned',
  FORMATIVE_ASSIGNED = 'formative_assigned',
  LESSON_GUIDED_ASSIGNED = `${AssignmentType.LESSON_GUIDED}_assigned`,
  INDEPENDENT_ASSIGNED = `${AssignmentType.INDEPENDENT}_assigned`,
  CONTINUOUS_ASSIGNED = `${AssignmentType.CONTINUOUS}_assigned`,
  ASSESSMENTS_GRADED = 'assessments_graded'
}

export enum FormativeRowTypes {
  FORMATIVE_QUIZ = 'formative_quiz',
  LESSON_GUIDED_PRACTICE = 'lesson_guided_practice',
  INDEPENDENT_PRACTICE = 'independent_practice',
  CONTINUOUS_PRACTICE = 'continuous_practice'
}
